<template>
  <div
    id="FunMeunBar"
    class="v-contextmenu"
    ref="FunMeunBar"
    v-show="showFunMeunBarFLag"
  >
    <!-- <div class="v-contextmenu-item">
      <p @click="drawPlan">显示计划</p>
    </div> -->
    <div class="v-contextmenu-item">
      <p v-if="!showdrawLocus()" @click="drawLocus">显示轨迹</p>
      <p v-else @click="closeDrawLocus">关闭轨迹</p>
    </div>
    <div class="v-contextmenu-item">
      <p v-if="!showWake()" @click="drawWake">显示尾迹</p>
      <p v-else @click="closeWake">关闭尾迹</p>
    </div>
    <div class="v-contextmenu-item">
      <p v-if="!isFollow()" @click="showFollow">关注</p>
      <p v-else @click="closeFollow">取消关注</p>
    </div>
    <div class="v-contextmenu-item">
      <p v-if="!showPredictLine()" @click="darwPredictLine">预计线</p>
      <p v-else @click="closePredictLine">关闭预计线</p>
    </div>
    <div class="v-contextmenu-item">
      <p v-if="showPunishAlarm()" @click="punishAlarm">处置告警</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { dealalarmbysn } from "@/request/api";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      showFunMeunBarFLag: "swichLayer/showFunMeunBarFLag",
      aircraftInfo: "swichLayer/aircraftInfo",
      ourMap: "swichLayer/ourMap",
    }),
  },
  methods: {
    ...mapMutations({
      changeshowFunMeunBarFLag: "swichLayer/changeshowFunMeunBarFLag",
    }),
    initPosition() {
      var pixel = map.latLngToContainerPoint([
        this.aircraftInfo.alLatitude,
        this.aircraftInfo.alLongitude,
      ]);
      console.log(pixel);
      this.$refs.FunMeunBar.style.left = pixel.x + "px";
      this.$refs.FunMeunBar.style.top = pixel.y + "px";
    },
    showdrawLocus() {
      if (this.aircraftInfo.showLocus) {
        return true;
      } else {
        return false;
      }
    },

    showWake() {
      if (this.aircraftInfo.showWake) {
        return true;
      } else {
        return false;
      }
    },

    isFollow() {
      if (this.aircraftInfo.isFollow) {
        return true;
      } else {
        return false;
      }
    },
    showPredictLine() {
      if (this.aircraftInfo.showPredictLine) {
        return true;
      } else {
        return false;
      }
    },
    showPunishAlarm() {
      if (this.aircraftInfo.alarmShow) {
        return true;
      } else {
        return false;
      }
    },
    drawPlan() {
      this.changeshowFunMeunBarFLag(false);
      //点击飞机
      if (
        Number(this.aircraftInfo.airLocationInfo.alAltitude) >=
          this.aircraftInfo.alarmHeight[0] &&
        Number(this.aircraftInfo.airLocationInfo.alAltitude) <=
          this.aircraftInfo.alarmHeight[1]
      ) {
        //点击当前高度飞机
        if (this.aircraftInfo.isShowLabel) {
          if (this.aircraftInfo.partOfGeneralCompany) {
            this.ourMap.showPlan(this.aircraftInfo);
          }
        }
      }
    },
    //开启关注
    showFollow() {
      this.changeshowFunMeunBarFLag(false);
      this.aircraftInfo.showFollow();
    },
    //开启轨迹
    drawLocus() {
      this.changeshowFunMeunBarFLag(false);
      this.aircraftInfo.showDrawAdsbLocus(this.aircraftInfo.sn);
    },
    //关闭轨迹
    closeDrawLocus() {
      this.changeshowFunMeunBarFLag(false);
      if (this.aircraftInfo.hideLocus) {
        this.aircraftInfo.hideLocus();
      }
    },
    //开启尾迹
    drawWake() {
      this.changeshowFunMeunBarFLag(false);
      this.aircraftInfo.showDrawAdsbWake(this.aircraftInfo.icao);
    },
    //开启预计线
    darwPredictLine() {
      this.changeshowFunMeunBarFLag(false);
      this.aircraftInfo.showDarwPredictLine();
    },
    //处置告警
    async punishAlarm() {
      this.changeshowFunMeunBarFLag(false);
      let res = await dealalarmbysn({ sn: this.aircraftInfo.sn });
      if (res) {
        this.$alert("处置成功", "提醒", {
          confirmButtonText: "确定",
        });
        this.aircraftInfo.alarmShow = false;
      }
    },
    //关闭预计线
    closePredictLine() {
      this.changeshowFunMeunBarFLag(false);
      this.aircraftInfo.hidePredictLine();
    },
    //关闭尾迹
    closeWake() {
      this.changeshowFunMeunBarFLag(false);
      this.aircraftInfo.hideWake();
    },
    //关闭关注
    closeFollow() {
      this.changeshowFunMeunBarFLag(false);
      this.aircraftInfo.hideFollow();
    },
    //关闭所有轨迹
    closeAllDrawLocus() {
      this.ourMap.hideAllLocus();
    },
    //关闭所有尾迹
    closeAllDrawWake() {
      this.ourMap.hideAllWake();
    },
    //关闭所有预计线
    closeAllPredictLine() {
      this.ourMap.hideAllPredictLine();
    },
    //关闭所有预计线
    closeAllFollow() {
      this.ourMap.hideAllFollow();
    },
  },
  watch: {
    showFunMeunBarFLag(val) {
      this.initPosition();
      if (val) {
      } else {
      }
    },
    $route(val) {
      if (
        this.ourMap.hideAllLocus ||
        this.ourMap.hideAllWake ||
        this.ourMap.hideAllPredictLine ||
        this.ourMap.hideAllFollow
      ) {
        this.closeAllDrawLocus();
        this.closeAllDrawWake();
        this.closeAllPredictLine();
        this.closeAllFollow();
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    if (
      this.ourMap.hideAllLocus ||
      this.ourMap.hideAllWake ||
      this.ourMap.hideAllPredictLine ||
      this.ourMap.hideAllFollow
    ) {
      this.closeAllDrawLocus();
      this.closeAllDrawWake();
      this.closeAllPredictLine();
      this.closeAllFollow();
    }
  },
};
</script>
<style lang="less" scoped>
#FunMeunBar {
  position: absolute;
  z-index: 3;
  padding: 10px 0;
  background-color: #fff;
  cursor: pointer;
}

.v-contextmenu {
  position: absolute;
  padding: 5px 0;
  margin: 0;
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  -webkit-box-shadow: 2px 2px 8px 0 hsl(0deg 0% 59% / 20%);
  box-shadow: 2px 2px 8px 0 hsl(0deg 0% 59% / 20%);
  list-style: none;
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  z-index: 2800;
  -webkit-tap-highlight-color: transparent;
}
.v-contextmenu .v-contextmenu-item {
  padding: 0 4px;
  line-height: 1;
  color: #333;
}
.v-contextmenu .v-contextmenu-item:hover {
  background-color: #2d3035;
  color: #fff;
}
#FunMeunBar p {
  padding: 8px 10px !important;
}
</style>